import BusinessEntity, { EntityManager, EntityManagerParameters } from '@xFrame4/business/base/BusinessEntity';
import { BusinessEntityFieldType } from '@xFrame4/business/base/Constants';
import { ManyToManyCollection } from '@xFrame4/business/base/ManyToManyCollection';
import { BusinessEntityWithTranslation, BusinessEntityTranslation, EntityWithTranslationManager, EntityTranslationManager, EntityWithTranslationManagerParameters } from '@xFrame4/business/base/BusinessEntityWithTranslation';

import RoomType from '@business/rooms/RoomType';


export class RoomTypeTranslationGeneratedEntityManager<B extends RoomTypeTranslationGenerated> extends EntityTranslationManager<B>
{

    constructor(parameters: EntityManagerParameters<B>)
    {
        super({
            name: parameters.name ?? 'RoomTypeTranslation',
            createEntity: parameters.createEntity,
            fields: [
				{ name: 'roomType', type: BusinessEntityFieldType.ForeignKey, isRequiredInput: true, inputName: 'roomTypeId', inputProperty: 'roomType.id', relatedManager: RoomType.manager },
				{ name: 'name', type: BusinessEntityFieldType.VarChar, isRequiredInput: true },
				{ name: 'description', type: BusinessEntityFieldType.Text },
				{ name: 'descriptionExtra', type: BusinessEntityFieldType.Text },
				{ name: 'seoTitle', type: BusinessEntityFieldType.VarChar },
				{ name: 'seoDescription', type: BusinessEntityFieldType.Text },
				{ name: 'seoKeywords', type: BusinessEntityFieldType.Text },
				{ name: 'slug', type: BusinessEntityFieldType.VarChar },
                ... parameters.fields ?? [],
            ],
            graphQlQueryAlias: parameters.graphQlQueryAlias ?? 'roomTypeTranslations',
        });
    }

}
export class RoomTypeTranslationGenerated extends BusinessEntityTranslation
{
	/** The name of the foreign key to the translated entity. */
	translatedEntityForeignKeyName: string = 'roomType';
	/** The ID of the room type this translation belongs to. */
	roomType!: RoomType;
	/** The translated name of the room type. */
	name!: string;
	/** The translated description of the room type. */
	description: string = '';
	/** The translated extra description of the room type. */
	descriptionExtra: string = '';
	/** Meta title. */
	seoTitle: string = '';
	/** Meta description. */
	seoDescription: string = '';
	/** Meta keywords. */
	seoKeywords: string = '';
	/** A unique slug that can be used in URLs. Generated automatically from the `title` field or the field set as the `title` field. */
	slug!: string;

}

export default RoomTypeTranslationGenerated;